import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import CustomButton from 'utils/CustomButton';
import CloseIcon from 'assets/closeIcon.svg';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "40%",
    bgcolor: 'background.paper',
    borderRadius: "0.625rem",
    boxShadow: 24,
};

export default function CopyHierarchyModal(props) {
    return (
        <Modal
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="copy-hierarchy-modal-title"
            aria-describedby="copy-hierarchy-modal-description"
        >
            <Box sx={style}>
                <Box
                    sx={{
                        background: "#F2BB40",
                        borderTopLeftRadius: "0.625rem",
                        borderTopRightRadius: "0.625rem",
                        p: 4,
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography
                            id="copy-hierarchy-modal-title"
                            sx={{ fontWeight: 600, fontSize: "1.25rem", color: "#191E31" }}
                        >
                            Add
                        </Typography>
                        <img
                            style={{ cursor: "pointer" }}
                            onClick={props.onClose}
                            src={CloseIcon}
                            alt="Close Icon"
                        />
                    </Box>
                </Box>
                <Box sx={{ p: 4 }}>
                    <Typography id="copy-hierarchy-modal-description" sx={{ fontWeight: 500, fontSize: "1.125rem" }}>
                        {props.hasPreviousYearData ? (
                            <>
                                You are creating a hierarchy configuration for Crop Year{" "}
                                <span style={{ fontWeight: 700 }}>({props.cropYear})</span>. Do you want to use the same hierarchy setup from the previous Crop Year?
                            </>
                        ) : (
                            "No hierarchy configuration is available for the previous Crop Year. Please configure the hierarchy manually."
                        )}
                    </Typography>
                    <Box
                        sx={{
                            mt: 4,
                            justifyContent: "flex-end",
                            display: "flex",
                            gap: "1rem",
                        }}
                    >
                        {props.hasPreviousYearData ? (
                            <>
                                <CustomButton variant="cancel" onClick={props.onNo} label="No" />
                                <CustomButton onClick={props.onYes} label="Yes" loading={props.loading} />
                            </>
                        ) : (
                            <CustomButton onClick={props.onNo} label="OK" />
                        )}
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
}
